module.exports = __webpack_public_path__ + "img/hearts@2x.7ce3863.jpg";